import {useSuspenseQuery} from '@tanstack/react-query';
import {queryKey} from './material-variation-machine-preselect-query-keys';
import {MaterialVariationMachinePreselectReply} from './material-variation-machine-preselect.model';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';

export function useMaterialVariationMachinePreselectQuery(
  variationId: number,
): MaterialVariationMachinePreselectReply {
  const {data} = useSuspenseQuery({
    queryKey: queryKey.detail(variationId),
    queryFn: () => AxiosHttpClient.get<MaterialVariationMachinePreselectReply>(
      `${environment.apiv4uri}material/variation/${variationId}/preselect`,
    ),
  });

  return data;
}
